import { getTree } from '@/api/tree'

const tree = {
  state: {
    data: null,
    operate: false
  },
  mutations: {
    SET_TREE: (state, data) => {
      state.data = data;
    },
    SET_TREE_OPER: (state, status) => {
      state.operate = status;
    }
  },
  actions: {
    async GetTreeData({ commit }) {
      try {
        await getTree().then(response => {
          commit('SET_TREE', [response.data]);
          commit('SET_TREE_OPER', true);
        })
      } catch (error){
        throw (new Error(error));
      }
    }
  }
}

export default tree;



// WEBPACK FOOTER //
// ./src/store/modules/tree.js